export const uiTooltip = {
    name: 'UI Tooltip',
    description: '',
    displayField: 'triggerText',
    fields: {
        triggerText: {
            name: 'Trigger text',
            type: 'Symbol',
            required: true,
            localized: true,
            disabled: false,
            omitted: false,
            validations: []
        },
        tooltipText: {
            name: 'Tooltip text',
            type: 'RichText',
            required: true,
            localized: true,
            disabled: false,
            omitted: false,
            validations: [
                { nodes: {} },
                {
                    enabledMarks: ['bold', 'italic', 'underline'],
                    message: 'Only bold, italic, and underline marks are allowed'
                },
                {
                    enabledNodeTypes: ['unordered-list', 'ordered-list', 'hyperlink'],
                    message: 'Only unordered list, ordered list, and link to Url nodes are allowed'
                }
            ]
        }
    }
};
//# sourceMappingURL=uiTooltip.js.map